import type { CSSProperties } from "react";

/** 产品订阅详情页与购买弹框布局配置（仅本模块生效） */
export interface SpaceProductSubscribeConfig {
  /** 详情页底部「立即订阅」栏额外 bottom padding（px），增大后按钮整体上移 */
  subscribePageFootBottomPaddingExtra: number;
  /** 购买弹框底部「取消 / 订阅」栏额外 bottom padding（px），增大后按钮整体上移 */
  purchaseSheetFootBottomPaddingExtra: number;
}

const SUBSCRIBE_PAGE_FOOT_PADDING_TOP = 12;
const SUBSCRIBE_PAGE_FOOT_PADDING_BOTTOM_BASE = 12;
const SUBSCRIBE_PAGE_FOOT_BUTTON_HEIGHT = 48;
/** 详情页海报区底部留白 = 顶内边距 + 按钮高 + 底内边距 */
const SUBSCRIBE_PAGE_PADDING_BOTTOM_BASE =
  SUBSCRIBE_PAGE_FOOT_PADDING_TOP +
  SUBSCRIBE_PAGE_FOOT_BUTTON_HEIGHT +
  SUBSCRIBE_PAGE_FOOT_PADDING_BOTTOM_BASE;

const PURCHASE_SHEET_INNER_PADDING_BOTTOM_BASE = 16;

export const SPACE_PRODUCT_SUBSCRIBE = {
  subscribePageFootBottomPaddingExtra: 30,
  purchaseSheetFootBottomPaddingExtra: 30,
} as const satisfies SpaceProductSubscribeConfig;

/** 产品订阅详情页：底部订阅栏与海报留白 */
export function spaceProductSubscribePageCssVars(
  config: SpaceProductSubscribeConfig = SPACE_PRODUCT_SUBSCRIBE
): CSSProperties {
  const extra = config.subscribePageFootBottomPaddingExtra;
  const footPaddingBottom = SUBSCRIBE_PAGE_FOOT_PADDING_BOTTOM_BASE + extra;
  const pagePaddingBottom = SUBSCRIBE_PAGE_PADDING_BOTTOM_BASE + extra;
  return {
    ["--h5-product-subscribe-foot-padding-bottom" as string]: `${footPaddingBottom}px`,
    ["--h5-product-subscribe-page-padding-bottom" as string]: `${pagePaddingBottom}px`,
  };
}

/** 购买弹框：底部取消 / 订阅按钮区留白 */
export function spaceProductPurchaseSheetCssVars(
  config: SpaceProductSubscribeConfig = SPACE_PRODUCT_SUBSCRIBE
): CSSProperties {
  const extra = config.purchaseSheetFootBottomPaddingExtra;
  const innerPaddingBottom = PURCHASE_SHEET_INNER_PADDING_BOTTOM_BASE + extra;
  return {
    ["--h5-product-purchase-sheet-inner-padding-bottom" as string]: `${innerPaddingBottom}px`,
  };
}
